import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './SalesOrders.frontend.types'

@Injectable({ providedIn: 'root' })
export class SalesOrders_process_orders_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { order_ids: number[], options: { processing_strategy_code: string, cartonization_strategy_code: string, break_child_serials?: boolean, merge_onto_single_shipment?: boolean, expand_order_line_kits?: boolean }, shipment_ids?: number[] }): Promise<{ order_results?: { order_id: number, is_succeeded: boolean, reason?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_ids)) {
      $missingRequiredInParams.push('\'order_ids\'');
    }
    if (isNil($inParams.options)) {
      $missingRequiredInParams.push('\'options\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

